import { useEffect } from "react";
import { useNavigate } from "react-router";
import { signal } from "@preact/signals-react";

import { layoutStaffSupply } from "../models/LayoutStaffSupply";
import Button from "componentsv2/button/Button";
import { PlusIcon, ArcheryIcon, TimeIcon } from "components/Icons";
import LayoutView from "../layouts/LayoutView";
import Board from "componentsv2/board/Board";
import { useLayout } from "hooks/layout";
import { useTable } from "storev2/tableStore";

const activeTab = signal("activas");
const currentView = signal("list");

const MainRequest = () => {
  const navigate = useNavigate();

  const { resetDomains } = useTable();

  const _LayoutStaffSupply = useLayout(layoutStaffSupply);

  async function handleTabChange(tab) {
    activeTab.value = tab;
    const newDomain =
      tab === "historial"
        ? [["state", "=", "done"]]
        : [["state", "!=", "done"]];

    _LayoutStaffSupply.domain = newDomain;
    resetDomains();
  }

  /** 🔹 Estilos para los botones del tab */
  function getButtonStyles(isActive) {
    return {
      button: `rounded-t-xl rounded-b-none border-none transition-colors duration-200 group ${
        isActive
          ? "!bg-[#1f2937FF] text-white"
          : "!bg-transparent text-[#1f2937FF] hover:!bg-[#1f2937FF] hover:text-white"
      }`,
      icon: `w-6 h-6 fill-current transition-colors duration-200 ${
        isActive
          ? "text-white"
          : "text-[#1f2937FF] hover:text-white group-hover:text-white"
      }`,
    };
  }

  /** 🔹 Cuando seleccionas un registro de la tabla */

  useEffect(() => {
    handleTabChange("activas");
  }, []);

  return (
    <LayoutView title={"Solicitudes dotación personal"} link={"staff_supply"}>
      <div className="w-full relative">
        <div className="border-b border-[#1f2937FF]/30 w-full mt-4 flex justify-between">
          <div className="flex top-[1px] relative w-[400px]">
            {(() => {
              const { button, icon } = getButtonStyles(
                activeTab.value === "activas",
              );
              return (
                <Button
                  content="Solicitudes activas"
                  style={button}
                  iconLeft={<ArcheryIcon className={icon} />}
                  size="w-full"
                  onClick={() => handleTabChange("activas")}
                />
              );
            })()}

            {(() => {
              const { button, icon } = getButtonStyles(
                activeTab.value === "historial",
              );
              return (
                <Button
                  content="Historial"
                  style={`w-full ${button} group`}
                  iconLeft={<TimeIcon className={icon} />}
                  size="w-full"
                  onClick={() => handleTabChange("historial")}
                />
              );
            })()}
          </div>

          <div className="-mt-3 flex flex-col justify-end">
            <Button
              content="staff_supply.request.create"
              style="!bg-[#ffcc00FF] absolute -top-[71px] right-0 font-medium space-x-1"
              size="w-[186px]"
              onClick={() => navigate("/dash/staff_supply/add_request")}
            >
              <PlusIcon className="w-6 h-6 bg-amber-500 rounded-full" />
            </Button>
          </div>
        </div>

        {/* Tabla */}
        <Board
          key={activeTab.value}
          layout={_LayoutStaffSupply}
          currentView={currentView}
        />
      </div>
    </LayoutView>
  );
};

export default MainRequest;
